import createAction from '../services/create-action';

export const CLEAR_FOLLOWING = 'following/CLEAR';
export const clearFollowing = createAction(CLEAR_FOLLOWING);



// WEBPACK FOOTER //
// ./app/actions/clear-following.js